import { render, staticRenderFns } from "./EventReminder4.vue?vue&type=template&id=3ff13f2c&"
import script from "./EventReminder4.vue?vue&type=script&lang=js&"
export * from "./EventReminder4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports